import $ from "jquery";
import coreSearchSidebarFilter from './search-filters';

export function coreSearchModal(modal) {
    // If not provided, get whatever one is currently shown
    if (!modal) {
        modal = $('.modal.show');
    }
    // If a jQuery object wasn't provided, treat this as a selector
    if ('string' === typeof modal) {
        if ('#' === modal.charAt(0)) {
            modal = $(modal).first();
        } else {
            modal = $('#' + modal).first();
        }
    }
    // props
    this.jQueryObj = modal;
    this.id = modal.attr('id');

    this.isAjaxModal = function () {
        return this.jQueryObj.hasClass('core-search-modal-ajax');
    };
    this.ajaxIsSearching = function () {
        return this.jQueryObj.hasClass('core-search-modal-ajax-is-searching');
    };
    this.ajaxHasSearched = function () {
        return this.jQueryObj.hasClass('core-search-modal-ajax-has-searched');
    };
    this.ajaxApiNonceName = function () {
        return this.jQueryObj.data('api-nonce-name');
    };
    this.ajaxApiNonceVal = function () {
        return this.jQueryObj.data('api-nonce-val');
    };
    this.inputName = function () {
        return this.jQueryObj.data('input-name');
    }
    this.sidebarFilter = function () {
        return $('#' + this.jQueryObj.data('filter-box-id'));
    };
    this.unselectedWrapper = function () {
        return $(this.jQueryObj.find('.core-search-modal-unselected-results-wrapper')).first();
    };
    this.selectedWrapper = function () {
        return $(this.jQueryObj.find('.core-search-modal-selected-results-wrapper')).first();
    };
    this.searchTerms = function () {
        let searchInput = this.jQueryObj.find('.core-search-modal-search');
        if (!searchInput.length) {
            return [];
        }
        return coreSearchModalfn.getTermsFromString($(searchInput[0]).val());
    };
    this.unselectedOptionElements = function () {
        return this.unselectedWrapper().getAllFilterOptionElements();
    };
    this.unselectedOptionObjects = function () {
        return this.unselectedWrapper().getAllFilterOptionObjects();
    };
    this.selectedOptionElements = function () {
        return this.selectedWrapper().getAllFilterOptionElements();
    };
    this.selectedOptionObjects = function () {
        return this.selectedWrapper().getAllFilterOptionObjects();
    };
    this.reorderSelectedOptionElements = function () {
        let options = this.selectedOptionObjects();
        let selectedWrapper = this.selectedWrapper();
        options.sort(function (a, b) {
            return b.data.originalOrder - a.data.originalOrder;
        });
        options.reverse(); // Ascending order
        options.forEach(function (option) {
            let formCheck = option.getFromModal(this);
            formCheck.appendTo(selectedWrapper);
        }, this);
    };
    this.reorderUnselectedOptionElements = function () {
        let options = this.unselectedOptionObjects();
        let unselectedWrapper = this.unselectedWrapper();

        options.sort(function (a, b) {
            return b.data.originalOrder - a.data.originalOrder;
        });
        options.reverse(); // Ascending order
        options.forEach(function (option) {
            let formCheck = option.getFromModal(this);
            formCheck.appendTo(unselectedWrapper);
        }, this);

    };
    this.getCheckboxParent = function (parentId, ancestor) {
        if (!ancestor) {
            ancestor = this.jQueryObj;
        }
        return ancestor.find('.core-search-form-check [value="' + parentId + '"]');
    };
    this.getCheckboxChildren = function (parentId, ancestor) {
        if (!ancestor) {
            ancestor = this.jQueryObj;
        }
        return ancestor.find('.core-search-form-check[data-parent-id="' + parentId + '"] .form-check-input');
    };
    this.indentCheckbox = function (checkbox) {
        // Get the parent core-search-form-check jQuery object
        if (!checkbox instanceof jQuery) {
            checkbox = $(checkbox);
        }
        let formCheck = checkbox.hasClass('.core-search-form-check')
            ? checkbox
            : checkbox.closest('.core-search-form-check');
        // Add metadata to say this is indented
        formCheck.data('is-indented', '1');
        if (!formCheck.hasClass('core-search-mobile-modal-filter-indent')) {
            formCheck.addClass('core-search-mobile-modal-filter-indent');
        }
    };
    this.unindentCheckbox = function (checkbox) {
        // Get the parent core-search-form-check jQuery object
        if (!checkbox instanceof jQuery) {
            checkbox = $(checkbox);
        }
        let formCheck = checkbox.hasClass('.core-search-form-check')
            ? checkbox
            : checkbox.closest('.core-search-form-check');
        // Remove metadata that says this is indented
        formCheck.data('is-indented', '').removeClass('core-search-mobile-modal-filter-indent');
    };
    this.removeSearchHighlighting = function () {
        this.unselectedOptionElements().find('mark').contents().unwrap();
    };
    this.highlightSearchMatches = function () {
        let terms = this.searchTerms();
        if (!terms || !terms.length) {
            return;
        }
        // For ajax, only highlight terms that are at least three characters long
        if (this.isAjaxModal()) {
            terms = terms.filter(function (term) {
                return term.length >= 3;
            }, 0);
        }
        // Convert to array of regex expressions so that matching is case insensitive
        const termRegExps = terms.map(function (term) {
            return {
                'regExp': new RegExp(term, "i"),
                'length': term.length
            };
        });
        this.unselectedWrapper().children('.form-check:not(.core-option-no-match)').find('.core-search-form-check-text').each(function (i) {
            let label = $(this);
            let text = label.html();
            // Identify where highlighting should be added, but don't add until all locations have been found
            termRegExps.forEach(function (term) {
                if (term.length < 1) {
                    return;
                }
                let position = text.search(term.regExp);
                if (position < 0) {
                    return;
                }
                text = text.slice(0, position) + '^^^' + text.slice(position, position + term.length) + '$$$' + text.slice(position + term.length);
            });
            // Now add the actual marks
            text = text.replaceAll("^^^", "<mark>").replaceAll("$$$", "</mark>");
            label.html(text);
            // Remove nested marks
            label.find('mark mark').contents().unwrap();
        });

    };
    this.moveItemFromUnselectedToSelected = function (checkbox) {
        let formCheck = checkbox.closest('.core-search-form-check');
        formCheck.moveToModalSelectedOptions(this);

        // See if there is a parent-child relationship to update
        let parentId = formCheck.data('parent-id');;

        // If this is a child, find all inputs with the same parent class in the unselected wrapper. If empty, move the parent
        if (parentId) {
            let uncheckedChildren = this.getCheckboxChildren(parentId, this.unselectedWrapper());
            if (!uncheckedChildren.length) {
                let parentCheckbox = this.getCheckboxParent(parentId);
                parentCheckbox.closest('.core-search-form-check').moveToModalSelectedOptions(this);
            }
        } else {
            // If this is a parent, check all children
            let childCheckboxes = this.getCheckboxChildren(checkbox.val(), this.unselectedWrapper());
            childCheckboxes.closest('.core-search-form-check').moveToModalSelectedOptions(this);
        }

        // Reorder selected options
        this.reorderSelectedOptionElements();
        // Update headings and messages
        this.updateHeadingsIndentsAndNoResultsMessage();
    };
    this.moveItemFromSelectedToUnselected = function (checkbox) {
        let formCheck = checkbox.closest('.core-search-form-check');
        formCheck.moveToModalUnselectedOptions(this);

        // See if there is a parent-child relationship to update
        let parentId = formCheck.data('parent-id');

        // If this is a child, find all inputs with the same parent class in the unselected wrapper. If empty, move the parent
        if (parentId) {
            this.getCheckboxChildren(parentId, this.selectedWrapper());
            let parentCheckbox = this.getCheckboxParent(parentId);
            parentCheckbox.closest('.core-search-form-check').moveToModalUnselectedOptions(this);
        } else {
            // If this is a parent, check all children
            let children = this.getCheckboxChildren(checkbox.val(), this.selectedWrapper()).closest('.core-search-form-check');
            children.each(function (i) {
                $(this).moveToModalUnselectedOptions(this);
            });
        }

        // Update headings and messages
        this.updateHeadingsIndentsAndNoResultsMessage();
    };
    this.updateHeadingsIndentsAndNoResultsMessage = function () {
        let modalObj = this.jQueryObj;
        // Update selected heading
        if (this.selectedWrapper().children().length) {
            $(modalObj.find('.core-search-modal-selected-heading')).show();
        } else {
            $(modalObj.find('.core-search-modal-selected-heading')).hide();
        }
        // Remove search highlighting (will be added later if needed)
        this.removeSearchHighlighting();
        // Update no matches found message
        if (this.isAjaxModal()) {
            if (this.ajaxIsSearching()) {
                // Currently searching
                $(modalObj.find('.core-search-modal-ajax-is-searching-message')).show();
                $(modalObj.find('.core-search-modal-ajax-start-typing-message')).hide();
                $(modalObj.find('.core-search-modal-no-matches-found-message')).hide();
                $(modalObj.find('.core-search-modal-all-heading')).show();
                $(modalObj.find('.core-search-modal-matching-heading')).hide();
            } else {
                $(modalObj.find('.core-search-modal-ajax-is-searching-message')).hide();
                if (this.ajaxHasSearched()) {
                    // Has searched
                    $(modalObj.find('.core-search-modal-ajax-start-typing-message')).hide();
                    $(modalObj.find('.core-search-modal-all-heading')).hide();
                    $(modalObj.find('.core-search-modal-matching-heading')).show();
                    if (this.unselectedWrapper().children('.form-check:not(.core-option-no-match)').length) {
                        // Results found
                        $(modalObj.find('.core-search-modal-no-matches-found-message')).hide();
                        this.highlightSearchMatches();
                    } else {
                        // Nothing found
                        $(modalObj.find('.core-search-modal-no-matches-found-message')).show();
                    }
                } else {
                    // Has not searched yet
                    $(modalObj.find('.core-search-modal-all-heading')).show();
                    $(modalObj.find('.core-search-modal-matching-heading')).hide();
                    $(modalObj.find('.core-search-modal-ajax-start-typing-message')).show();
                    $(modalObj.find('.core-search-modal-no-matches-found-message')).hide();
                }
            }
        } else {
            // Update unselected (matching/all) headings
            if (modalObj.find('.core-search-modal-search').val()?.length) {
                // Searching
                $(modalObj.find('.core-search-modal-all-heading')).hide();
                $(modalObj.find('.core-search-modal-matching-heading')).show();
            } else {
                // Not searching
                $(modalObj.find('.core-search-modal-all-heading')).show();
                $(modalObj.find('.core-search-modal-matching-heading')).hide();
            }
            if (this.unselectedWrapper().children('.form-check:not(.core-option-no-match)').length) {
                // Results found
                $(modalObj.find('.core-search-modal-no-matches-found-message')).hide();
                this.highlightSearchMatches();
            } else {
                // Nothing found
                $(modalObj.find('.core-search-modal-no-matches-found-message')).show();
            }
        }

        // Update indenting (e.g. ref types)
        let modal = this;
        let unselectedWrapper = this.unselectedWrapper();
        let unselectedOptionElements = this.unselectedOptionElements();
        unselectedOptionElements.each(function (i) {
            let checkbox = $(this);
            let parentId = checkbox.closest('.core-search-form-check').data('parent-id');
            if (!parentId) {
                return;
            }
            let unselectedParent = modal.getCheckboxParent(parentId, unselectedWrapper);
            if (unselectedParent.length) {
                // Parent is also in this list, so indent it
                modal.indentCheckbox(checkbox);
            } else {
                // Parent is not in this list, so unindent
                modal.unindentCheckbox(checkbox);
            }
        });
        let selectedOptionElements = this.selectedOptionElements();
        let selectedWrapper = this.selectedWrapper();
        selectedOptionElements.each(function (i) {
            let checkbox = $(this);
            let parentId = checkbox.data('parent-id');
            if (!parentId) {
                return;
            }
            let selectedParent = modal.getCheckboxParent(parentId, selectedWrapper);
            if (selectedParent.length) {
                // Parent is also in this list, so indent it
                modal.indentCheckbox(checkbox);
            } else {
                // Parent is not in this list, so unindent
                modal.unindentCheckbox(checkbox);
            }
        });
    };
    this.filterAndSortPreloadedResults = function (terms) {
        // Get unselected options
        let options = this.unselectedOptionObjects();
        // Identify what options match the search terms
        let matches = [];
        let misses = [];
        options.forEach(function (option) {
            option.relevance = coreSearchModalfn.calculateSearchResultRelevance(terms, option.haystackArray);
            if (option.relevance > 0) {
                matches.push(option);
            } else {
                misses.push(option);
            }
        }, this);
        // Hide misses
        misses.forEach(function (option) {
            option.getFromModal(this).addClass('core-option-no-match');
        }, this);
        // Reorder matches (in reverse order, so highest relevance is added to top last)
        let unselectedWrapper = this.unselectedWrapper();
        matches.sort(function (a, b) {
            if (b.relevance === a.relevance) {
                // If relevance scores are the same, use original order (pub count, author last name, author first name)
                return a.data.originalOrder - b.data.originalOrder;
            }
            return b.relevance - a.relevance;
        });
        matches.reverse(); // Ascending order
        matches.forEach(function (option) {
            let match = option.getFromModal(this);
            match.removeClass('core-option-no-match');
            match.prependTo(unselectedWrapper);
        }, this);

        // Update headings and messages
        this.updateHeadingsIndentsAndNoResultsMessage();
    };
    this.filterAndSortAjaxResults = function (terms) {
        // Remove previous results
        this.unselectedOptionElements().remove();

        // Make sure at least 3 characters are passed
        terms = terms.filter(function (term) {
            return term.length >= 3;
        }, 0);

        if (!terms.length) {
            // Not currently searching
            this.ajaxNotSearching();

            // Update headings and messages
            this.updateHeadingsIndentsAndNoResultsMessage();
            return;
        }
        // Create the cache for this search
        if (!coreSearchAjaxSearchCache[this.id]) {
            coreSearchAjaxSearchCache[this.id] = {};
        }
        // Add terms that were searched to this list
        let thisCache = coreSearchAjaxSearchCache[this.id];
        let termsStringified = JSON.stringify(terms);

        // Set what the most recent search is (in case user searches again while ajax is loading)
        coreSearchAjaxLatest.modalId = this.id;
        coreSearchAjaxLatest.termsStringified = termsStringified;

        // Look for this search in the cache
        if (undefined === thisCache[termsStringified]) {
            // Search doesn't exist in cache. Submit a new ajax search
            coreSearchAjaxSearchCache[this.id][termsStringified] = false;
            this.submitNewAjaxSearch(terms);
        } else {
            // False means this request has been submitted but hasn't returned yet
            if (false === thisCache[termsStringified]) {
                // Return to appearing as searching
                this.jQueryObj.addClass('core-search-modal-ajax-is-searching').removeClass('core-search-modal-ajax-has-searched');
            } else {
                // Already found in cache. Update with known values
                this.updateAjaxUnselectedResults(termsStringified);

                // Also make sure any previously called ajax requests don't overwrite this data
                coreSearchAjaxLatest.modalId = false;
                coreSearchAjaxLatest.termsStringified = false;
            }
        }

        // Update headings and messages
        this.updateHeadingsIndentsAndNoResultsMessage();
    };
    this.submitNewAjaxSearch = function (terms) {
        // Update classes
        this.jQueryObj.addClass('core-search-modal-ajax-is-searching').removeClass('core-search-modal-ajax-has-searched');

        // Update headings and messages
        this.updateHeadingsIndentsAndNoResultsMessage();

        // Perform Search
        let data = {
            filter: this.inputName(),
            terms: terms,
            form_data: $('#core-search-sidebar-form').serialize()
        };
        $.ajax({
            type: 'get',
            dataType: 'json',
            url: searchApi.baseUrl + "/modal/",
            data: data,
            success(response, textStatus, jqXHR) {
                let options = coreSearchModalfn.sortAjaxResults(response.data.terms, Object.entries(response.data.options));
                coreSearchAjaxSearchCache[response.data.id][JSON.stringify(response.data.terms)] = options;
            },
        });
    };
    this.updateAjaxUnselectedResults = function (termsStringified) {
        // Update checkboxes
        let selectedOptions = this.selectedOptionObjects();
        let selectedOptionIds = selectedOptions.map(function (selected) {
            return String(selected.data.value);
        });
        let matches = coreSearchAjaxSearchCache[this.id][termsStringified];
        let template = this.formCheckTemplate();
        let before = this.unselectedWrapper().children('p:first-of-type');
        matches.forEach(function (option) {
            if (selectedOptionIds.includes(option[0])) {
                return;
            }
            this.appendUnselectedOption(option, template, before);
        }, this);

        // Complete. update headings and search status
        this.jQueryObj.addClass('core-search-modal-ajax-has-searched').removeClass('core-search-modal-ajax-is-searching');
        // Ordering is not needed because results are ordered before adding them to the ajax cache
        this.updateHeadingsIndentsAndNoResultsMessage();
    };
    this.appendUnselectedOption = function (option, template, before) {
        let formCheck = template.clone();
        let input = formCheck.find('input');
        let label = formCheck.find('label');
        let text = formCheck.find('.core-search-form-check-text');
        let optionCount = formCheck.find('.core-search-badge-filter-count');
        let removeText = formCheck.find('.core-search-mobile-remove-input .sr-only');

        // Add attributes to core-search-form-check
        for (const attr in option[1]['form-check-attributes']) {
            formCheck.attr(attr, option[1]['form-check-attributes'][attr]);
        }

        // Add attributes to form-check-input
        for (const attr in option[1]['input-attributes']) {
            input.attr(attr, option[1]['input-attributes'][attr]);
        }

        // Add attributes to form-check-input
        option[1]['input-props'].forEach(function (option) {
            input.prop(option['input-props'][attr], true);
        });

        // Add attributes to form-check-label
        for (const attr in option[1]['input-attributes']) {
            label.attr(attr, option[1]['label-attributes'][attr]);
        }

        // Add text to form-check-label
        text.text(option[1]['label-text']);

        // Add option count
        optionCount.text(option[1]['option-count']);

        // Add remove text
        removeText.text('Remove ' + option[1]['label-text'] + ' from filter');

        // Insert Unselected Option
        formCheck.insertBefore(before);
    };
    this.formCheckTemplate = function () {
        return this.jQueryObj.find('.core-search-modal-checkbox-template > div');
    };
    this.ajaxNotSearching = function () {
        if (!this.isAjaxModal()) {
            return;
        }
        // Update modal class (status)
        this.jQueryObj.removeClass('core-search-modal-ajax-is-searching').removeClass('core-search-modal-ajax-has-searched');
        // Remove previous results
        this.unselectedOptionElements().remove();
        // Also make sure any previously called ajax requests don't overwrite this data
        coreSearchAjaxLatest.modalId = false;
        coreSearchAjaxLatest.termsStringified = false;
    };
}

$(document).on('ajaxStop', function () {
    // Check if the latest ajax request is for the currently open modal
    let modal = new coreSearchModal();
    if (!modal || !coreSearchAjaxLatest.modalId || modal.id !== coreSearchAjaxLatest.modalId) {
        return;
    }

    // See if the last requested ajax data exists
    if (!coreSearchAjaxSearchCache.hasOwnProperty(coreSearchAjaxLatest.modalId) || !coreSearchAjaxSearchCache[coreSearchAjaxLatest.modalId].hasOwnProperty(coreSearchAjaxLatest.termsStringified)) {
        return; // Expected cache doesn't exist
    }

    // Success. Modal is still active and last ajax request's cache exists
    modal.updateAjaxUnselectedResults(coreSearchAjaxLatest.termsStringified);
    modal.jQueryObj.removeClass('core-search-modal-ajax-is-searching').addClass('core-search-modal-ajax-has-searched');
    modal.updateHeadingsIndentsAndNoResultsMessage();
});

const coreSearchAjaxSearchCache = {};

const coreSearchAjaxLatest = {
    modalId: '',
    termsStringified: ''
}

const coreSearchModalfn = {
    getTermsFromString: function (string) {
        if (!string) {
            return [];
        }
        string = String(string);
        // clean up input
        string = string.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");
        string = string.replace(/\s{2,}/g, " ");
        string = string.toLowerCase();
        return string.split(' ').filter(i => i);
    },
    calculateSearchResultRelevance: function (terms, haystackArray) {
        let relevance = 0;
        for (let i = 0; i < terms.length; i++) {
            relevance += coreSearchModalfn.calculateSingleTermRelevance(terms[i], haystackArray);
        }
        return relevance;
    },
    calculateSingleTermRelevance: function (term, haystackArray) {
        // Exact match trumps everything. Bonus points for matching a longer term, 
        // then to break ties value earlier terms slightly more
        for (let i = 0; i < haystackArray.length; i++) {
            let haystackIndexBonus = 10 - i;
            if (term === haystackArray[i]) {
                return 100 + term.length * 10 + haystackIndexBonus;
            }
        }

        // Next, look for a partial match at the start
        const startRegExp = new RegExp('^' + term);
        for (let i = 0; i < haystackArray.length; i++) {
            let haystackIndexBonus = 10 - i;
            if (startRegExp.test(haystackArray[i])) {
                return term.length * 10 + haystackIndexBonus;
            }
        }
        // partial match anywhere
        const anyRegExp = new RegExp(term);
        for (let i = 0; i < haystackArray.length; i++) {
            let haystackIndexBonus = 10 - i;
            if (anyRegExp.test(haystackArray[i])) {
                return term.length * 5 + haystackIndexBonus;
            }
        }
        // maybe add more possibilities if fuzzy matching would be helpful
        return 0;
    },
    sortAjaxResults: function (terms, options) {
        options.forEach(function (option) {
            option[1]['relevance'] = coreSearchModalfn.calculateSearchResultRelevance(terms, coreSearchModalfn.getTermsFromString(option[1]['form-check-attributes']['data-haystack']));
        });
        options.sort(function (a, b) {
            if (b[1]['relevance'] === a[1]['relevance']) {
                // If relevance scores are the same, use original order (search result count, author last name, author first name)
                return a[1]['form-check-attributes']['data-original-order'] - b[1]['form-check-attributes']['data-original-order'];
            }
            return b[1]['relevance'] - a[1]['relevance'];
        });
        return options;
    }
}


/* ************************************************************* */
/*                     Search Filter Option                      */
/* ************************************************************* */
export function coreSearchFilterOption(formCheck) {
    // Basic Data
    this.data = formCheck.data();
    this.haystackArray = coreSearchModalfn.getTermsFromString(this.data.haystack);
    this.relevance = 0; // Can be calculated later

    this.getFromModal = function (modal) {
        if (modal instanceof coreSearchModal) {
            modal = modal.jQueryObj;
        }
        return modal.find('[data-wrapper-id="' + this.data.wrapperId + '"]');
    };

    this.getFromSidebar = function (sidebar) {
        if (sidebar instanceof coreSearchSidebarFilter) {
            sidebar = sidebar.jQueryObj;
        }
        return sidebar.find('[data-wrapper-id="' + this.data.wrapperId + '"]');
    };
}


/* ************************************************************* */
/*                       jQuery extensions                       */
/* ************************************************************* */
jQuery.fn.extend({
    moveToModalSelectedOptions: function (modal) {
        $(this).find('.form-check-input').prop('checked', true);
        modal.selectedWrapper().append(this);
    },
    moveToModalUnselectedOptions: function (modal) {
        let formCheck = $(this);
        // Uncheck this (in case it is unselected without actually unchecking the checkbox)
        formCheck.find('.form-check-input').prop('checked', false);
        // Check if this checkbox should now be hidden because it doesn't match the current search term
        let option = new coreSearchFilterOption(this);
        let terms = modal.searchTerms();
        if (terms.length) {
            if (!coreSearchModalfn.calculateSearchResultRelevance(terms, option.haystackArray)) {
                formCheck.hide();
            }
        }

        // Move the selected item into its proper place based on original order
        let added = false;
        $(modal.unselectedWrapper().children('.core-search-form-check')).each(function (i) {
            if (parseInt($(this).data('original-order')) > option.data.originalOrder) {
                $(this).before(formCheck);
                added = true;
                return false;
            }
        });
        // If this wasn't added for some reason, add it to the beginning
        if (!added) {
            modal.unselectedWrapper().append(formCheck);
        }
    },
    moveToSidebarUnselectedOptions: function (sidebar) {
        // Append to Sidebar Unselected Wrapper
        this.find('.form-check-input').each(function (i) {
            let $this = $(this);
            $this.prop('checked', false);
        });
        sidebar.unselectedWrapper().append(this);
    },
    moveToSidebarSelectedOptions: function (sidebar) {
        // Append to Sidebar Selected Wrapper
        this.find('.form-check-input').prop('checked', true);
        sidebar.selectedWrapper().append(this);
    },
    getFilterOptionElement: function (wrapperId) {
        return $(this).find('.core-search-form-check[data-wrapper-id="' + wrapperId + '"]');
    },
    getFilterOptionObject: function (wrapperId) {
        let elem = $(this).find('.core-search-form-check[data-wrapper-id="' + wrapperId + '"]');
        if (!elem || !elem.length) {
            return false;
        }
        return new coreSearchFilterOption($(this));
    },
    getAllFilterOptionElements: function () {
        return $(this).find('.core-search-form-check');
    },
    getAllFilterOptionObjects: function () {
        let options = [];
        $(this).getAllFilterOptionElements().each(function (i) {
            options.push(new coreSearchFilterOption($(this)));
        });
        return options;
    },
    hasFilterOption: function (wrapperId) {
        return $(this).find('.core-search-form-check[data-wrapper-id="' + wrapperId + '"]').length;
    },
    convertToSidebarOption: function () {
        let sidebarCheckboxId = this.data('sidebar-checkbox-id');
        this.find('.form-check-input').attr("id", sidebarCheckboxId);
        this.find('.form-check-label').attr("for", sidebarCheckboxId).find('mark').contents().unwrap();
        return this;
    },
    convertToModalOption: function () {
        let modalCheckboxId = this.data('modal-checkbox-id');
        this.find('.form-check-input').attr("id", modalCheckboxId);
        this.find('.form-check-label').attr("for", modalCheckboxId);
        return this;
    }
});

/* ************************************************************* */
/*                    Execute Search in Modal                    */
/* ************************************************************* */
jQuery(function () {
    // Search within modal
    $('.core-search-results').on('input', '.core-search-modal-search', function (e) {
        let modal = new coreSearchModal();
        // Terms are an array of strings that the user is searching for
        let terms = modal.searchTerms();
        if (!terms.length) {
            // Show all unselected elements
            modal.unselectedOptionElements().each(function (i) {
                $(this).removeClass('core-option-no-match');
            });
            // Reorder to original ordering
            modal.reorderUnselectedOptionElements();

            // Update headings and messages
            modal.updateHeadingsIndentsAndNoResultsMessage();
            return;
        }
        if (modal.isAjaxModal()) {
            modal.filterAndSortAjaxResults(terms);
        } else {
            modal.filterAndSortPreloadedResults(terms);
        }
    });
});


/* ************************************************************* */
/*               Select/unselect option in Modal                 */
/* ************************************************************* */
jQuery(function () {
    // Move item from unselected to selected
    $('.core-search-results').on('change', '.core-search-modal-unselected-results-wrapper .form-check-input', function (e) {
        let modal = new coreSearchModal();

        // Move this checkbox and its wrapper to the selected list
        let checkbox = $(this);
        modal.moveItemFromUnselectedToSelected(checkbox);
    });
    // Move item from selected to unselected
    $('.core-search-results').on('change', '.core-search-modal-selected-results-wrapper .form-check-input', function (e) {
        let modal = new coreSearchModal();

        // Move this checkbox and its wrapper to the selected list
        let checkbox = $(this);
        modal.moveItemFromSelectedToUnselected(checkbox);
    });
});



/* ************************************************************* */
/*                Update modal before it is opened               */
/* ************************************************************* */
jQuery(function () {
    $('.core-search-results').on('show.bs.modal', '.core-search-modal', function () {
        let modal = new coreSearchModal($(this));
        let sidebar = new coreSearchSidebarFilter(modal.sidebarFilter());

        // Get list of items that should be checked
        let selectedOptionObjects = sidebar.selectedOptionObjects().concat(sidebar.unselectedOptionObjects());

        // Remove items that are unchecked
        for (let i = selectedOptionObjects.length - 1; i >= 0; i--) {
            let sidebarElement = selectedOptionObjects[i].getFromSidebar(sidebar);
            if (!sidebarElement.find('.form-check-input').is(':checked')) {
                selectedOptionObjects.splice(i, 1);
            }
        }

        // Star by clearing the modal selected items
        modal.selectedOptionElements().each(function (i) {
            $(this).moveToModalUnselectedOptions(modal);
        });

        // Now loop through selected items
        let modalUnselectedWrapper = modal.unselectedWrapper();
        selectedOptionObjects.forEach(function (option) {
            if (modalUnselectedWrapper.hasFilterOption(option.data.wrapperId)) {
                let modalElement = option.getFromModal(modal);
                modalElement.moveToModalSelectedOptions(modal);
            } else {
                // Doesn't exist, so clone the sidebar version and move (copy) it to modal selected
                let element = option.getFromSidebar(sidebar).clone().convertToModalOption();
                element.moveToModalSelectedOptions(modal);
            }
        });

        // Remove ajax classes
        modal.ajaxNotSearching();

        // Reorder selected and unselected items
        modal.reorderSelectedOptionElements();
        modal.reorderUnselectedOptionElements();
        modal.updateHeadingsIndentsAndNoResultsMessage();
    });
});

/* ************************************************************* */
/*          Update filters after modal is submitted              */
/* ************************************************************* */
jQuery(function () {
    // Update sidebar list when a modal is closed
    $('.core-search-results').on('click', '.core-search-modal .core-search-sidebar-update-button', function (event) {
        let modal = new coreSearchModal();
        let sidebar = new coreSearchSidebarFilter();

        // Get list of items that should be checked
        let selectedOptionObjects = modal.selectedOptionObjects();

        // Remove items that are unchecked
        for (let i = selectedOptionObjects.length - 1; i >= 0; i--) {
            let modalElement = selectedOptionObjects[i].getFromModal(modal);
            if (!modalElement.find('.form-check-input').is(':checked')) {
                selectedOptionObjects.splice(i, 1);
            }
        }

        // Remove .is-active class from sidebar filter box if all items removed
        if (!selectedOptionObjects.length) {
            sidebar.jQueryObj.removeClass('is-active');
        } else {
            if (!sidebar.jQueryObj.hasClass('is-active')) {
                sidebar.jQueryObj.addClass('is-active');
            }
        }

        // Star by clearing the sidebar selected items
        sidebar.selectedOptionElements().each(function (i) {
            $(this).moveToSidebarUnselectedOptions(sidebar);
        });

        // Now loop through selected items
        let sidebarUnselectedWrapper = sidebar.unselectedWrapper();
        selectedOptionObjects.forEach(function (option) {
            if (sidebarUnselectedWrapper.hasFilterOption(option.data.wrapperId)) {
                let sidebarElement = option.getFromSidebar(sidebar);
                sidebarElement.moveToSidebarSelectedOptions(sidebar);
            } else {
                // Doesn't exist, so clone the modal version and move (copy) it to sidebar selected
                let element = option.getFromModal(modal).clone().convertToSidebarOption();
                element.moveToSidebarSelectedOptions(sidebar);
            }
        });

        // Reorder selected and unselected items
        sidebar.reorderSelectedOptionElements();
        sidebar.reorderUnselectedOptionElements();

        // Disable buttons and update text
        $('.core-search-filter-submit').prop('disabled', true);
        $(this).html('Updating...').prop('disabled', true);

        // Submit sidebar form
        $('#core-search-sidebar-form').trigger('submit');
    });
});

/* ************************************************************* */
/*            Clear modal search after it is closed              */
/* ************************************************************* */
jQuery(function () {
    $('.core-search-results').on('hidden.bs.modal', '.core-search-modal', function () {
        let modal = new coreSearchModal($(this));
        // Clear search input
        modal.jQueryObj.find('.core-search-modal-search').val('');
        // Show all unselected elements
        modal.unselectedOptionElements().each(function (i) {
            $(this).removeClass('core-option-no-match');
        });
        // Reorder to original ordering
        modal.reorderUnselectedOptionElements();

        // Update headings and messages
        modal.updateHeadingsIndentsAndNoResultsMessage();
    });
});
